export default __webpack_public_path__ + "static/media/rabdomiolisis.627e4991.pdf";